import appLayout from '../layouts/AppLayout.vue'
export default [
  {
    path: '/search/tickets/kudenix',
    name: 'tickets-kudenix',
    component: () => import('../views/tickets/kudenix/agency/index.vue'),
    meta: { layout: appLayout }
  },
  {
    path: '/tickets/options/kudenix',
    name: 'tickets-options-kudenix',
    component: () => import('../views/tickets/kudenix/agency/options.vue'),
    meta: { layout: appLayout }
  },
  {
    path: '/tickets/reserve/kudenix',
    name: 'tickets-reserve-kudenix',
    component: () => import('../views/tickets/kudenix/agency/reserve.vue'),
    meta: { layout: appLayout }
  }
]
